import React, { createContext, useState } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
	const [userId, setUserId] = useState(null);
	const [isFip, setIsFIP] = useState(false);
	const [consentCache, setConsentCache] = useState({
		allAccounts: [],
		mobileNumber: '',
		AAHandle: '',
		isValid: false
	});

	const updateConsentCache = (data) => {
		setConsentCache({
			...data,
			isValid: true
		});
	};

	const clearConsentCache = () => {
		setConsentCache({
			allAccounts: [],
			mobileNumber: '',
			AAHandle: '',
			isValid: false
		});
	};

	return (
		<UserContext.Provider value={{ 
			userId, 
			setUserId, 
			isFip, 
			setIsFIP,
			consentCache,
			updateConsentCache,
			clearConsentCache
		}}>
			{children}
		</UserContext.Provider>
	);
};
